export default __webpack_public_path__ + "static/media/J_Jornal.993368f6.mp3";